import { render } from "./CounselRegister.vue?vue&type=template&id=c413ee44"
import script from "./CounselRegister.vue?vue&type=script&lang=js"
export * from "./CounselRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__